import { Notificator } from "@sizdevteam1/funjoiner-uikit";

const notificator = new Notificator();
export default notificator;
